import React, { forwardRef, ReactNode } from 'react'
import { Button, ButtonProps, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface IProps {
    processing?: boolean
    icon?: string
    link?: string
}

export const AdvancedButton = forwardRef<HTMLButtonElement, IProps & ButtonProps>(({ children, processing, disabled, icon, link, ...rest }, ref) => {
    let prefix: ReactNode | null = null;
    if (processing) {
        prefix = <Spinner size='sm' />
    } else if (icon) {
        prefix = <i className={`bi ${icon}`} />
    }

    const renderButton = () => {
        return (
            <Button {...rest} ref={ref} disabled={processing || disabled}>
                <div className='center gap-2'>{prefix} {children}</div>
            </Button>
        )
    }

    if (link) {
        return <Link to={link} className='text-decoration-none'>
            {renderButton()}
        </Link>
    }


    return renderButton();
})
